import { withFormField } from "@swa-ui/form";
import { ItineraryRecentSearch } from "@swa-ui/itinerary";

export const RecentSearchFormField = withFormField(ItineraryRecentSearch, {
  shouldRegister: false,
});
